var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doAuth)?_c('div',[_c('auth-frame',{key:_vm.frameKey})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }